import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NeoInfoboxModule } from '@neogov/pattern-library/neo-infobox';

export type InfoboxUrgency = 'none' | 'low' | 'medium' | 'high';

/**
 * Colour treatment of the infobox.
 *
 * - `default`: the Pattern Library look driven by `urgency` (neutral/green/amber/red
 *   fill, no border, `width: fit-content`).
 * - `info`: full-width informational note — teal text on a tinted teal background
 *   with a subtle border. Use for "this is managed elsewhere / read-only" notices.
 */
export type InfoboxColor = 'default' | 'info';

@Component({
  selector: 'cm-infobox',
  standalone: true,
  imports: [CommonModule, NeoInfoboxModule],
  templateUrl: './infobox.component.html',
  styleUrl: './infobox.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoboxComponent {
  public readonly urgency = input<InfoboxUrgency>('none');
  public readonly message = input<string>('');
  public readonly showContent = input<boolean>(false);
  public readonly color = input<InfoboxColor>('default');
}
